import i18n from '@/i18n'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
  try {
    // Translation
    if (i18n.locale === 'bn') {
      pdfMake.vfs = pdfFontsBn.pdfMake.vfs
    } else {
        pdfMake.vfs = pdfFontsEn.pdfMake.vfs
    }

    // API Call
    const reportHeading = await ReportHeading.getReportHead(baseUrl, uri, orgId)

    // PDF
    const pdfContent = []

    //
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['25%', '50%', '25%'],
          body: [
            [
              { image: reportHeading.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
              { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
              { image: reportHeading.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
            ],
            [
              {},
              { text: vm.$t('social_service.dss'), style: 'header2', alignment: 'center' },
              {}
            ],
            [
              {},
              { text: reportHeading.heading, style: 'address', alignment: 'center' },
              {}
            ],
            [
              {},
              { text: reportHeading.address, style: 'address', alignment: 'center' },
              {}
            ],
            [
              {},
              { text: reportTitle, style: 'address2', alignment: 'center' },
              {}
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      }
    )

    //
    pdfContent.push(
      {
        table: {
          style: 'tableData',
          headerRows: 0,
          widths: ['50%', '50%'],
          body: [
            [
              { text: vm.$t('report_monthly.worlplace_name') + ' : ' + (titleData.worlplace_name ? titleData.worlplace_name : ''), style: 'th', alignment: 'left' },
              {}
            ],
            [
              { text: vm.$t('report.month_name') + ' : ' + titleData.month_name, style: 'th', alignment: 'left' },
              {}
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      }
    )

    //
    pdfContent.push(
      { text: '', style: 'empty_space' }
    )

    // i
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          body: [
            // 1
            [
              { text: vm.$t('report_monthly.money_prv_moth'), colSpan: 8, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {
                text: `${vm.$t('report_monthly.financialy')} ${vm.$t('report_monthly.progressive')}  ${vm.$t('report_monthly.patients')}  ${vm.$t('report_monthly.total')}  ${vm.$t('report_monthly.number')}  ${vm.$t('report_monthly.tot_one_eight')}`,
                rowSpan: 2,
                style: 'th',
                alignment: 'center'
              }
            ],
            // 2
            [
              { text: vm.$t('report_monthly.medicine'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.different_type_test'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.blood_cloth'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.wheel_chair_and_products'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.milk_diet'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.transportation_fair_deadbody_burial_ritual'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.dialisis_therapy'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.others_help'), style: 'th', alignment: 'center' },
              {}
            ],
            // 3
            [
              { text: vm.$n(1), style: 'th', alignment: 'center' },
              { text: vm.$n(2), style: 'th', alignment: 'center' },
              { text: vm.$n(3), style: 'th', alignment: 'center' },
              { text: vm.$n(4), style: 'th', alignment: 'center' },
              { text: vm.$n(5), style: 'th', alignment: 'center' },
              { text: vm.$n(6), style: 'th', alignment: 'center' },
              { text: vm.$n(7), style: 'th', alignment: 'center' },
              { text: vm.$n(8), style: 'th', alignment: 'center' },
              { text: vm.$n(9), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.medicine), style: 'th', alignment: 'center' },
              { text: vm.$n(data.different_type_test), style: 'th', alignment: 'center' },
              { text: vm.$n(data.blood) + '/' + vm.$n(data.cloth), style: 'th', alignment: 'center' },
              { text: vm.$n(data.wheel_chair_and_products), style: 'th', alignment: 'center' },
              { text: vm.$n(data.milk_diet), style: 'th', alignment: 'center' },
              { text: vm.$n(data.transportation_fair_deadbody_burial_ritual), style: 'th', alignment: 'center' },
              { text: vm.$n(data.dialisis_therapy), style: 'th', alignment: 'center' },
              { text: vm.$n(data.others_help), style: 'th', alignment: 'center' },
              { text: vm.$n(data.financialy), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )

    //
    pdfContent.push(
      { text: '', style: 'empty_space' }
    )

    // ii
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          body: [
            // 1
            [
              { text: vm.$t('report_monthly.tot_finan'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('report_monthly.number_socio'), colSpan: 5, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.socio_bene'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            // 2
            [
              { text: vm.$t('report_monthly.women'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.man'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.baby'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.counseling'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.recreation'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.social_act'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.follow_up_report'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.social_awarness'), style: 'th', alignment: 'center' },
              {}
            ],
            // 3
            [
              { text: vm.$n(10), style: 'th', alignment: 'center' },
              { text: vm.$n(11), style: 'th', alignment: 'center' },
              { text: vm.$n(12), style: 'th', alignment: 'center' },
              { text: vm.$n(13), style: 'th', alignment: 'center' },
              { text: vm.$n(14), style: 'th', alignment: 'center' },
              { text: vm.$n(15), style: 'th', alignment: 'center' },
              { text: vm.$n(16), style: 'th', alignment: 'center' },
              { text: vm.$n(17), style: 'th', alignment: 'center' },
              { text: vm.$n(18), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.gender_women), style: 'th', alignment: 'center' },
              { text: vm.$n(data.gender_man), style: 'th', alignment: 'center' },
              { text: vm.$n(data.gender_baby), style: 'th', alignment: 'center' },
              { text: vm.$n(data.counseling), style: 'th', alignment: 'center' },
              { text: vm.$n(data.recreation), style: 'th', alignment: 'center' },
              { text: vm.$n(data.social_act), style: 'th', alignment: 'center' },
              { text: vm.$n(data.follow_up_report), style: 'th', alignment: 'center' },
              { text: vm.$n(data.social_awarness), style: 'th', alignment: 'center' },
              { text: vm.$n(data.socio_bene), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )

    // Page Break
    pdfContent.push(
      { text: '', style: 'empty_space', pageBreak: 'before' }
    )

    // iii
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%', '6.6%'],
          body: [
            // 1
            [
              { text: vm.$t('report.social_bene_gender'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('report.rehab_report'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.rehab_socio_bene_gender'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('report.tot_rehab'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.benefit_pat_tot_num'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.bene_pat_gen'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('report.benefit_pat_tot_nums'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.benefit_pat_tot_num_disbale'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.comment'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            // 2
            [
              { text: vm.$t('report_monthly.women'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.man'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.baby'), style: 'th', alignment: 'center' },
              {},
              { text: vm.$t('report_monthly.women'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.man'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.baby'), style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('report.woman_third'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.man_third'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.baby_third'), style: 'th', alignment: 'center' },
              {},
              {},
              {}
            ],
            // 3
            [
              { text: vm.$n(19), style: 'th', alignment: 'center' },
              { text: vm.$n(20), style: 'th', alignment: 'center' },
              { text: vm.$n(21), style: 'th', alignment: 'center' },
              { text: vm.$n(22), style: 'th', alignment: 'center' },
              { text: vm.$n(23), style: 'th', alignment: 'center' },
              { text: vm.$n(24), style: 'th', alignment: 'center' },
              { text: vm.$n(25), style: 'th', alignment: 'center' },
              { text: vm.$n(26), style: 'th', alignment: 'center' },
              { text: vm.$n(27), style: 'th', alignment: 'center' },
              { text: vm.$n(28), style: 'th', alignment: 'center' },
              { text: vm.$n(29), style: 'th', alignment: 'center' },
              { text: vm.$n(30), style: 'th', alignment: 'center' },
              { text: vm.$n(31), style: 'th', alignment: 'center' },
              { text: vm.$n(32), style: 'th', alignment: 'center' },
              { text: vm.$n(33), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.gender_social_women), style: 'th', alignment: 'center' },
              { text: vm.$n(data.gender_social_man), style: 'th', alignment: 'center' },
              { text: vm.$n(data.gender_social_baby), style: 'th', alignment: 'center' },
              { text: vm.$n(data.rehab_report), style: 'th', alignment: 'center' },
              { text: vm.$n(data.gender_social_rehab_women), style: 'th', alignment: 'center' },
              { text: vm.$n(data.gender_social_rehab_man), style: 'th', alignment: 'center' },
              { text: vm.$n(data.gender_social_rehab_baby), style: 'th', alignment: 'center' },
              { text: vm.$n(data.tot_rehab), style: 'th', alignment: 'center' },
              { text: vm.$n(data.benefit_pat_tot_num), style: 'th', alignment: 'center' },
              { text: vm.$n(data.woman_third), style: 'th', alignment: 'center' },
              { text: vm.$n(data.man_third), style: 'th', alignment: 'center' },
              { text: vm.$n(data.baby_third), style: 'th', alignment: 'center' },
              { text: vm.$n(data.benefit_pat_tot_nums), style: 'th', alignment: 'center' },
              { text: (data.benefit_pat_tot_num_disbale), style: 'th', alignment: 'center' },
              { text: (data.comment), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )

    var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      styles: {
          th: {
            fontSize: 10,
            margin: [3, 3, 3, 3],
            bold: true
          },
          td: {
            fontSize: 8,
            margin: [3, 3, 3, 3]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
      }
    }

    pdfMake.createPdf(docDefinition, null, null, null).print()
  } catch (error) {
    if (error) {
      //
    }
  }
}

export default {
  exportPdfDetails
}
